<div class="h-full flex flex-col justify-start items-start space-y-4">

    <div
        class="flex-0 flex flex-row items-start justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 overflow-visible">
        <div class="w-full flex flex-row gap-x-4">
            <div class="flex-1 p-2 flex flex-row items-center justify-start">
                @switch (magicSearchService.searchMode()) {
                @case ('search') {
                <magic-searchbar-v2 class="w-full"></magic-searchbar-v2>
                }
                @case ('filters') {
                <magic-filters class="w-full"></magic-filters>
                }
                @case ('foryou') {
                For You
                }
                @default {
                default
                }
                }
            </div>

            <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
                <div class="px-1 py-1 dark:bg-white/10 bg-gray-100 rounded-full flex flex-row items-center gap-x-1">
                    <button type="button" position="bottom" (click)="magicSearchService.searchMode.set('search');"
                        class="inline-flex items-center gap-x-1.5 rounded-full py-1.5 px-2 hover:bg-primary/85 hover:text-white hover:cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                        [class]="magicSearchService.searchMode() === 'search' ? 'bg-primary text-white' : 'bg-transparent text-gray-500 dark:text-gray-400'">
                        Search
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="m21 21-4.34-4.34" />
                            <circle cx="11" cy="11" r="8" />
                        </svg>
                    </button>
                    <button type="button" [appTooltip]="'Filters'" position="bottom"
                        (click)="magicSearchService.searchMode.set('filters'); magicSearchService.filtersOpen.set(true);"
                        class="inline-flex items-center gap-x-1.5 rounded-full py-1.5 px-2 hover:bg-primary/85 hover:text-white hover:cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                        [class]="magicSearchService.searchMode() === 'filters' ? 'bg-primary text-white' : 'bg-transparent text-gray-500 dark:text-gray-400'">
                        Filters
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                        </svg>
                    </button>
                    <button type="button" [appTooltip]="'For You'" position="bottom"
                        (click)="magicSearchService.searchMode.set('foryou'); magicSearchService.filtersOpen.set(false);"
                        class="inline-flex items-center gap-x-1.5 rounded-full py-1.5 px-2 hover:bg-primary/85 hover:text-white hover:cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                        [class]="magicSearchService.searchMode() === 'foryou' ? 'bg-primary text-white' : 'bg-transparent text-gray-500 dark:text-gray-400'">
                        For You
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path
                                d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                            <path d="M20 2v4" />
                            <path d="M22 4h-4" />
                            <circle cx="4" cy="20" r="2" />
                        </svg>
                    </button>
                </div>


                <!-- Collaborators Button -->
                <div class="relative overflow-visible">
                    <button type="button" (click)="collaboratorsService.showCollaborators.set(true)"
                        class="btn-fab-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <path d="M16 5H3" />
                            <path d="M11 12H3" />
                            <path d="M16 19H3" />
                            <path d="M18 9v6" />
                            <path d="M21 12h-6" />
                        </svg>
                    </button>
                    @if (collaboratorsService.selectedCreators().length > 0) {
                    <span
                        class="z-10 absolute -top-3 -right-3 inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-sm font-medium text-accent ring-1 ring-inset ring-primary/15">
                        {{ collaboratorsService.selectedCreators().length }}</span>
                    }
                </div>
                <!-- Collaborators Button -->

                <!-- Screening Button -->
                <div class="relative overflow-visible">
                    <button type="button" (click)="socialScreeningService.showToBeScreeneed.set(true)"
                        class="btn-fab-custom bg-teal-500 text-white hover:bg-teal-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6">
                            <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                            <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                            <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                            <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                            <path d="M8 7v10" />
                            <path d="M12 7v10" />
                            <path d="M17 7v10" />
                        </svg>
                    </button>
                    @if (socialScreeningService.selectedCreators().length > 0) {
                    <span
                        class="z-10 absolute -top-3 -right-3 inline-flex items-center rounded-full bg-teal-50 px-2 py-0.5 text-sm font-medium text-teal-700 ring-1 ring-inset ring-teal-700/10">
                        {{ socialScreeningService.selectedCreators().length }}</span>
                    }
                </div>
                <!-- Screening Button -->
            </div>
        </div>
    </div>

    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @switch (magicSearchService.searchMode()) {
        @case ('search') {
        <cv2-searched-creators></cv2-searched-creators>
        }
        @case ('filters') {
        <cv2-filtered-creators></cv2-filtered-creators>
        }
        @case ('foryou') {
        <cv2-for-you-creators></cv2-for-you-creators>
        }
        @default {
        default
        }
        }
    </div>

</div>

@if (collaboratorsService.showCollaborators()) {
<cc-collaborators></cc-collaborators>
}
@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}
@if (socialScreeningService.showToBeScreeneed()) {
<sb-creators-for-list></sb-creators-for-list>
}


@if (magicSearchService.previewVideo()) {
<atom-single-video-viewer-summary class="z-[999]" [video]="magicSearchService.previewVideo()!"
    (closePreviewOut)="magicSearchService.previewVideo.set(undefined)"></atom-single-video-viewer-summary>
}